module.exports = __webpack_public_path__ + "img/sybt.4ba1fe28.png";